import {TimelineMax} from 'gsap'; // eslint-disable-line no-unused-vars

export default {
  init() {
    // JavaScript to be fired on the home page

    function findHashtags(searchText) {
      var regexp = /\B#\w\w+\b/g;
      var result = searchText.match(regexp);

      if (result) {
          return result;
      } else {
          return false;
      }
    }


    $('.scroll-hint, .scroll-to a').on('click', function(e) {
      e.preventDefault();

      let hashes = findHashtags($(this).attr('href'));

      $('html, body').animate(
        {
          scrollTop: $(hashes[0]).offset().top,
        },
        1000
      )
    });

    $(window).scroll(function() {
      // selectors
      let $window = $(window),
          $header = $('.header'),
          $hero   = $('.section--hero');

      // Change 33% earlier than scroll position so colour is there when you arrive.
      let scroll = $window.scrollTop();

      if ( scroll >= $hero.outerHeight() ) {
        $header.addClass('fixed');
      } else {
        $header.removeClass('fixed');
      }
    }).scroll();

    let heroTimeline = new TimelineMax({paused: true});

    let heroMenuItems = document.querySelectorAll('.hero-menu .menu-item');
    let heroImage = document.querySelector('.hero-logo__image');
    let heroLang = document.querySelector('.section--hero .language-switcher .wpml-ls');

    heroTimeline.fromTo(heroLang, 1, {y: -30, opacity: 0}, {y: 0, opacity: 1}, 1.25);

    heroTimeline.fromTo(heroImage.querySelector('.top'), 1.5, {opacity: 0, y: -30}, {opacity: 1, y: 0, ease: 'Sine.easeInOut'}, 0.25)
                .staggerTo(heroImage.querySelectorAll('.center--left .logo-path'), 1, {opacity: 1, ease: 'Sine.easeInOut'}, 0.1, 0)
                .staggerTo(heroImage.querySelectorAll('.center--right .logo-path'), 1, {opacity: 1, ease: 'Sine.easeInOut'}, 0.1, 0)
                .fromTo(heroImage.querySelector('.bottom'), 1.5, {y: 30}, {opacity: 1, y: 0, ease: 'Sine.easeInOut'}, 0.25);

    heroTimeline.staggerFromTo(heroMenuItems, 1, {opacity: 0, y: 30}, {opacity: 1, y: 0, ease: 'Sine.easeInOut'}, 0.15, 1)

    heroTimeline.play();

    var video = document.querySelector('.section--hero .background__video');

    checkforVideo();
    function checkforVideo() {
        var b = setInterval(()=>{
            if(video.readyState >= 3){
                video.classList.add('loaded');
                clearInterval(b);
            }
        }, 10);
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js